import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const Payments = Loadable({
  loader: () => import('./containers/PaymentsContainer'),
  loading: Loading,
})

export default {
  path: '/payments',
  component: Payments
}



// WEBPACK FOOTER //
// ./src/routes/payments/index.js